import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IDiagnostic } from "apps/diagnostics/models/IDiagnostic";

interface IDiagnosticsState {
  value: IDiagnostic[];
}

const initialState: IDiagnosticsState = {
  value: [],
};

export const diagnosticsSlice = createSlice({
  name: "diagnostics",
  initialState,
  reducers: {
    setDiagnostics: (state, action: PayloadAction<IDiagnostic[]>): void => {
      state.value = action.payload;
    },
    addDiagnostic: (state, action: PayloadAction<IDiagnostic>): void => {
      state.value.push(action.payload);
    },
    updateDiagnosticInSlice: (
      state,
      action: PayloadAction<IDiagnostic>,
    ): void => {
      const index = state.value.findIndex(
        (diagnostic: IDiagnostic) => diagnostic.id === action.payload.id,
      );
      if (index !== -1) {
        state.value[index] = action.payload;
      }
    },
    removeDiagnostic: (state, action: PayloadAction<string>): void => {
      state.value = state.value.filter(
        (diagnostic: IDiagnostic) => diagnostic.id !== action.payload,
      );
    },
  },
});

export const {
  setDiagnostics,
  addDiagnostic,
  updateDiagnosticInSlice,
  removeDiagnostic,
} = diagnosticsSlice.actions;

export default diagnosticsSlice.reducer;
